import LabelCeController from './label.ce.controller';

export default {
    template: require('./label.ce.html'),
    controller: LabelCeController
};
